import { useState } from 'react';

import {
  EditButtonMui as EditButton,
  SidebarSectionMui as SidebarSection,
  SidebarValueMui as SidebarValue,
  SidebarValueWrapperMui as SidebarValueWrapper,
  useDisplayNames,
} from '@spotify/confidence-core-react';

import { EditAboutDialog } from '../../createMetricDialog/dialogs';

type AboutValue = {
  displayName: string;
  description?: string;
  owner: string;
};

type AboutSectionProps = {
  value: AboutValue;
  onChange: (value: AboutValue) => void;
};

export const AboutSection = ({ value, onChange }: AboutSectionProps) => {
  const [isEditing, setIsEditing] = useState(false);
  const { displayNames } = useDisplayNames();

  return (
    <>
      <SidebarSection.Root>
        <SidebarSection.Header>
          <SidebarSection.Title>About</SidebarSection.Title>
          <SidebarSection.Action>
            <EditButton size="small" onClick={() => setIsEditing(true)} />
          </SidebarSection.Action>
        </SidebarSection.Header>
        <SidebarSection.Content>
          <SidebarValueWrapper>
            <SidebarValue name="Name" singleLine value={value.displayName} />
            <SidebarValue name="Description" value={value.description || '-'} />
            <SidebarValue
              name="Owner"
              value={displayNames.get(value.owner) ?? value.owner}
            />
          </SidebarValueWrapper>
        </SidebarSection.Content>
      </SidebarSection.Root>

      <EditAboutDialog
        open={isEditing}
        value={value}
        onClose={() => setIsEditing(false)}
        onSubmit={newValue => {
          onChange(newValue);
          setIsEditing(false);
        }}
      />
    </>
  );
};
